import { MediaChange, MediaObserver } from '@ngbracket/ngx-layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

const EXACT_ALIASES = ['xs', 'sm', 'md', 'lg', 'xl'];

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService {
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Constructor
     *
     * @param {MediaObserver } _observableMedia
     */
    constructor(
        private _observableMedia: MediaObserver
    ) {
        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void {
        // asObservable() emits MediaChange[] (every active alias, overlapping
        // ones included), not a single MediaChange. Reduce it to the exact
        // breakpoint (xs|sm|md|lg|xl) — reading `.mqAlias` off the array gave
        // `undefined`, so this only fired once and lockedOpen sidebars never
        // reacted to later viewport changes.
        this._observableMedia.asObservable()
            .pipe(
                map((changes: MediaChange[]) => changes.find(change => EXACT_ALIASES.includes(change.mqAlias))?.mqAlias ?? ''),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((alias: string) => {
                if (this.activeMediaQuery !== alias) {
                    this.activeMediaQuery = alias;
                    this.onMediaChange.next(alias);
                }
            });
    }

}
